import { __extends, __assign, __rest } from '../../_virtual/_tslib.js';
import React from 'react';
import classnames from 'classnames';
import useBreakpoint from '../../hooks/useBreakpoint.js';
import hash from 'object-hash';
import isUndefined from 'lodash/isUndefined';
import ArrowDownIcon from './arrow-down.svg.js';
import styles from './styles.css.js';

var Option = function Option(_a) {
  var option = _a.option;
  return React.createElement("option", __assign({
    value: option.value,
    disabled: option.disabled,
    selected: option.selected
  }, option.optionProps), option.label);
};

var ResponsiveSelect =
/** @class */
function (_super) {
  __extends(ResponsiveSelect, _super);

  function ResponsiveSelect(props) {
    var _this = _super.call(this, props) || this;

    _this.selectRef = React.createRef();
    _this.state = {
      hasValue: isUndefined(_this.props.defaultValue) ? undefined : !!_this.props.defaultValue
    };
    _this.handleSelectChange = _this.handleSelectChange.bind(_this);
    return _this;
  }
  /**
   * Generate consistent ID for this input based on the props received:
   *  - Used to ensure the label and input are properly associated.
   *  - Must be consistent across server and browser renders.
   *  - Only used if an explicit `id` prop is not passed.
   */


  ResponsiveSelect.prototype.generateId = function () {
    return 'select-' + hash(this.props, {
      ignoreUnknown: true
    }).substr(0, 8);
  }; // Re-render component when ref is set. Ref assignment happens before componentDidMount lifecycle method
  // https://reactjs.org/docs/refs-and-the-dom.html#adding-a-ref-to-a-dom-element


  ResponsiveSelect.prototype.componentDidMount = function () {
    this.forceUpdate();
  };

  ResponsiveSelect.prototype.handleSelectChange = function (e) {
    // Only manage the input value if the value is not controlled by props
    if (isUndefined(this.props.value)) {
      this.setState({
        hasValue: !!(e.target.value && e.target.value.length > 0)
      });
    }

    if (this.props.onChange) {
      this.props.onChange(e);
    }
  };

  ResponsiveSelect.prototype.render = function () {
    var _a;

    var id = this.props.id || this.generateId();
    var testId = this.props.testId;
    var hasError = this.props.errorText !== undefined;
    var isDisabled = !!this.props.disabled;
    var isLabelHidden = !!this.props.labelHidden;
    var isSelectedOptionDisabled = this.selectRef.current && this.selectRef.current.options[this.selectRef.current.selectedIndex] && this.selectRef.current.options[this.selectRef.current.selectedIndex].disabled;
    return React.createElement("div", {
      className: classnames(styles.container, styles[this.props.size], (_a = {}, _a[styles.hasError] = hasError, _a[styles.isDisabled] = isDisabled, _a[styles.isSelectedOptionDisabled] = isSelectedOptionDisabled, _a[styles.isLabelHidden] = isLabelHidden, _a), this.props.className)
    }, React.createElement("div", {
      className: classnames(styles.selectContainer)
    }, React.createElement("label", {
      id: 'label-' + id,
      htmlFor: id,
      className: classnames(styles.label)
    }, this.props.label), React.createElement("div", {
      className: styles.innerSelectContainer
    }, React.createElement("select", __assign({
      id: id,
      ref: this.selectRef,
      "data-testid": testId,
      className: classnames(styles.select, this.props.selectClassName),
      defaultValue: this.props.defaultValue,
      disabled: this.props.disabled,
      name: this.props.name,
      onBlur: this.props.onBlur,
      onChange: this.handleSelectChange,
      onFocus: this.props.onFocus,
      value: this.props.value
    }, this.props.selectProps), this.props.options.map(function (optionOrOptionGroup) {
      if ('options' in optionOrOptionGroup) {
        return React.createElement("optgroup", __assign({
          label: optionOrOptionGroup.label,
          disabled: optionOrOptionGroup.disabled,
          key: 'optgroup' + hash(optionOrOptionGroup)
        }, optionOrOptionGroup.optGroupProps), optionOrOptionGroup.options.map(function (option) {
          return React.createElement(Option, {
            option: option,
            key: option.key || option.value.toString()
          });
        }));
      } else {
        return React.createElement(Option, {
          option: optionOrOptionGroup,
          key: optionOrOptionGroup.key || optionOrOptionGroup.value.toString()
        });
      }
    }))), this.props.icon && React.createElement(ArrowDownIcon, {
      className: styles.icon
    })), this.props.errorText && React.createElement("div", {
      className: styles.errorText
    }, this.props.errorText), this.props.successText && React.createElement("div", {
      className: styles.successText
    }, this.props.successText), this.props.helpText && React.createElement("div", {
      className: styles.helpText
    }, this.props.helpText));
  };

  ResponsiveSelect.defaultProps = {
    icon: true,
    size: 'medium'
  };
  return ResponsiveSelect;
}(React.Component);

var Select = function Select(_a) {
  var rest = __rest(_a, []);

  var isMobile = !useBreakpoint('sm');
  return React.createElement(ResponsiveSelect, __assign({
    isMobile: isMobile
  }, rest));
};

export default Select;
//# sourceMappingURL=index.js.map
